<app-video-service *ngIf="service?.category === 'video'" [data]="service" [language]="language"></app-video-service>
<app-course-details *ngIf="service?.category === 'Coursedetails'" [data]="service" [language]="language">
</app-course-details>
<div>
    <app-grid-text-with-image [data]="reviews" [language]="language"></app-grid-text-with-image>
</div>
<div class="container ">
    <app-text-with-image [data]="courses" [service]="service" [language]="language"></app-text-with-image>
</div>